<template>
  <div class="page-header">
    <span @click="goback">
      <slot name="custback">
        <el-button type="text"
                   v-if="isGoback"
                   class="go-back-btn">返回</el-button>
      </slot>
    </span>
    <el-divider direction="vertical"
                v-if="isGoback"
                class="divider"></el-divider>
    <slot>
      <strong v-if="title"
              class="title">{{title}}</strong>
      <span class="subtitle"
            v-if="subTitle">{{subTitle}}</span>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'page-header',
  props: {
    isGoback: {
      type: Boolean,
      default: true,
    },
    title: String,
    subTitle: String,
  },
  methods: {
    goback () {
      this.$router.go(-1)
      this.$emit('goback')
    },
  },
}
</script>

<style lang="scss" scoped>
.divider {
  height: 2.5em;
  margin: 0 20px;
}
.page-header .title {
  margin-right: 25px;
}
.page-header .subtitle {
  font-size: 14px;
  color: #666666;
  line-height: 18px;
}
.go-back-btn {
  font-size: 16px;
}
</style>